import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const CentersExcelRedux = createActions({
  CentersExcelRequest: ['path', 'centerId'],
  CentersExcelSuccess: [''],
  CentersExcelError: ['error'],
},
{
  prefix: 'CENTERS_EXCEL_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = CentersExcelRedux
export const CentersExcelTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const CentersExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const CentersExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const CentersExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CentersExcelRequest]: CentersExcelRequest,
  [Types.CentersExcelSuccess]: CentersExcelSuccess,
  [Types.CentersExcelError]: CentersExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CentersExcelRedux.js